import { handleErrors } from "@/modules/handleErrors";
export default {
  methods: {
    handleErrors,
    handleError: handleErrors
  }
};
